import { useState } from 'react';
import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface FAQProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function FAQ({ onOpenWhatsApp }: FAQProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Hangi alanlara catering hizmeti veriyorsunuz?',
      answer: 'Fabrika, şantiye, şirket ve ofisler, okul ve kurumlar, film/dizi setleri ve organizasyonlar için catering çözümleri sunuyoruz.',
      hasCTA: false,
    },
    {
      question: 'Kaç kişilik yemek hizmeti alabiliriz?',
      answer: 'İhtiyacınıza göre hizmet seçenekleri değerlendirilmektedir. Kişi sayınızı bize ileterek uygun çözüm hakkında bilgi alabilirsiniz.',
      hasCTA: false,
    },
    {
      question: 'Yemek fiyatları ne kadar?',
      answer: 'Fiyatlandırma; kişi sayısı, hizmet türü, bölge ve ihtiyaçlara göre değişebilir. En uygun teklif için bilgilerinizi WhatsApp üzerinden iletebilirsiniz.',
      hasCTA: true,
    },
    {
      question: 'Teklif almak için ne yapmalıyım?',
      answer: 'Kişi sayınızı, hizmet bölgenizi ve hangi alanda catering hizmetine ihtiyacınız olduğunu iletmeniz yeterlidir.',
      hasCTA: false,
    },
    {
      question: 'Şantiyelere yemek hizmetiniz var mı?',
      answer: 'Evet. İnşaat ve şantiyelerin çalışma düzenine uygun toplu yemek çözümleri sunulmaktadır.',
      hasCTA: false,
    },
    {
      question: 'Film ve dizi setlerine hizmet veriyor musunuz?',
      answer: 'Film ve dizi prodüksiyonlarının catering ihtiyaçları için de hizmet seçenekleri bulunmaktadır.',
      hasCTA: false,
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
        <div className="reveal text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
            SIKÇA SORULAN SORULAR
          </h2>
        </div>
        <div className="reveal space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden transition-all"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="font-heading text-lg md:text-xl text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-primary-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px]' : 'max-h-0'
                }`}
              >
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="font-body text-foreground-600 text-sm md:text-base leading-relaxed">
                    {faq.answer}
                  </p>
                  {faq.hasCTA && (
                    <button
                      onClick={() => onOpenWhatsApp()}
                      className="mt-4 inline-flex items-center gap-2 font-label text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      WhatsApp&apos;tan Teklif Al
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}